const weights = ['light', 'regular', 'medium', 'bold'];
const weightProp = {
    type: 'enum',
    values: weights,
    default: undefined,
    responsive: true,
};
export { weightProp };
//# sourceMappingURL=weight.prop.js.map